export const mails = {
  path: "/mail",
  name: "Mail",
  meta: { requiresAuth: true },
  component: () => import("@/views/ADMIN/Mail.vue"),
  redirect: { name: "mails-dashboard" },
  children: [
    {
      path: "dashboard",
      meta: { requiresAuth: true},
      name: "mails-dashboard",
      component: () => import("@/components/Mail/Dashboard.vue"),
    },    {
      path: "crear",
      meta: { requiresAuth: true},
      name: "mails-crear",
      component: () => import("@/components/Mail/Crear.vue"),
    },
    {
      path: "editar/:idCorreo",
      meta: { requiresAuth: true},
      name: "mails-editar",
      component: () => import("@/components/Mail/Crear.vue"),
      props: true,
    },
    {
      path: "historico",
      meta: { requiresAuth: true},
      name: "mails-historico",
      component: () => import("@/components/Mail/Historico.vue"),
    },
    {
      path: "recursos",
      meta: { requiresAuth: true},
      name: "mails-recursos",
      component: () => import("@/components/Mail/Recursos.vue"),
    }
  ],
};
